import OrderList from '@/pages/orders/OrderList';
import Order from '@/pages/orders/Order';

export default [
  {
    path: '/orders',
    name: 'OrderList',
    component: OrderList
  },
  {
    path: '/orders/:id',
    name: 'Order',
    component: Order
  }
];
